/*  MUI  */
import { Loop } from '@mui/icons-material';

/*  Shared  */
import { Transition } from 'application/Shared/Helpers';

/*  Components  */
import { Modal, ModalBody } from 'application/Shared/Modals';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const LoadingModal = ({ runningReport }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={runningReport}
            aria-labelledby="report-is-loading"
            TransitionComponent={Transition}
            maxWidth="md"
            data-testid="dialogBoxReportLoading"
            title={t('Reports.prompt_crunching_report')}
        >
            <ModalBody style={{ padding: '32px', textAlign: 'center' }}>
                <Loop
                    fontSize="large"
                    className="icon-spin"
                    sx={{ color: 'icon.primary' }}
                />
            </ModalBody>
        </Modal>
    );
};
